module.exports = __webpack_public_path__ + "static/SpaceMono-Regular-75e0485adb82c2df8066a55feb81730d.woff";